import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { FetchStatus } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { ConnectedServiceData } from '@lyrahealth-inc/shared-app-logic/src/features/connectedService/types'

import {
  GET_CONNECTED_SERVICES_FULFILLED,
  GET_CONNECTED_SERVICES_PENDING,
  GET_CONNECTED_SERVICES_REJECTED,
  UPDATE_CONNECTED_SERVICE_FULFILLED,
} from './connectedServiceActions'

const initialState = fromJS({
  connectedServices: null,
  connectedServiceLoadingStatus: null,
})

export default createReducer(initialState, {
  [GET_CONNECTED_SERVICES_PENDING]: ($$state: Map<string, any>) => {
    return $$state.set('connectedServiceLoadingStatus', FetchStatus.PENDING)
  },
  [GET_CONNECTED_SERVICES_FULFILLED]: ($$state: Map<string, any>, action: { payload: ConnectedServiceData[] }) => {
    return $$state
      .set('connectedServices', fromJS(action.payload))
      .set('connectedServiceLoadingStatus', FetchStatus.SUCCESS)
  },
  [GET_CONNECTED_SERVICES_REJECTED]: ($$state: Map<string, any>) => {
    return $$state.set('connectedServiceLoadingStatus', FetchStatus.ERROR)
  },
  [UPDATE_CONNECTED_SERVICE_FULFILLED]: ($$state: Map<string, any>, action: { payload: ConnectedServiceData }) => {
    const connectedServices = $$state.get('connectedServices')
    if (!connectedServices) return $$state
    const existingConnectedServiceIdx = connectedServices.findIndex(
      (cs: Map<string, any>) => cs.get('service') === action.payload.service,
    )
    if (existingConnectedServiceIdx === -1) return $$state
    const existingConnectedService = connectedServices.get(existingConnectedServiceIdx)
    const updatedConnectedService = existingConnectedService.set('consentToShare', action.payload.consentToShare)
    const updatedServices = connectedServices.set(existingConnectedServiceIdx, updatedConnectedService)
    return $$state.set('connectedServices', updatedServices)
  },
})
